import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { EMMAChartLayoutDirective } from '@emma-directives/emma-chart-layout.directive';
import { LayoutName } from 'emma-common-ts/emma';

import { EMMAChartLayoutBase } from './emma-chart-layout-base';
import { LayoutChartNumberComponent } from './layouts/chart-number.layout';
import { LayoutChartOnlyComponent } from './layouts/chart-only.layout';
import { LayoutChartTitleSidelabelsTotalComponent } from './layouts/chart-title-sidelabels-total.layout';
import { LayoutChartTitleTotalComponent } from './layouts/chart-title-total.layout';
import { LayoutPortletMinichartComponent } from './layouts/portlet-minichart.layout';
import { LayoutPortletTitleFooterlabelsFullheightComponent } from './layouts/portlet-title-footerlabels-fullheight.layout';
import { LayoutPortletTitleToplegendFullheightComponent } from './layouts/portlet-title-toplegend-fullheight.layout';
import { set } from 'lodash';

const layouts: { [k in LayoutName]: Type<EMMAChartLayoutBase> } = {
  'chart-number': LayoutChartNumberComponent,
  'chart-only': LayoutChartOnlyComponent,
  'chart-title-sidelabels-total': LayoutChartTitleSidelabelsTotalComponent,
  'chart-title-total': LayoutChartTitleTotalComponent,
  'portlet-title-footerlabels': LayoutPortletTitleFooterlabelsFullheightComponent,
  'portlet-title-toplegend': LayoutPortletTitleToplegendFullheightComponent,
  'portlet-minichart': LayoutPortletMinichartComponent,
};

@Component({
    selector: 'emma-chart-layout',
    template: ` <ng-template emmaChartLayoutHost></ng-template> `,
    standalone: false
})
export class EMMAChartLayoutComponent extends EMMAChartLayoutBase implements OnInit, OnChanges {
  @Input()
  layout!: LayoutName;

  @ViewChild(EMMAChartLayoutDirective, { static: true })
  layoutHost!: EMMAChartLayoutDirective;

  topLegends = [];

  viewContainerRef: ViewContainerRef | undefined;
  componentRef: ComponentRef<EMMAChartLayoutBase> | undefined;

  // To catch initial settings automatically
  private _cachedChanges: SimpleChanges = {};

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    super();
  }

  ngOnInit(): void {
    if (layouts[this.layout]) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(layouts[this.layout]);
      this.viewContainerRef = this.layoutHost.viewContainerRef;
      this.viewContainerRef.clear();
      this.componentRef = this.viewContainerRef.createComponent(componentFactory);
      this.ngOnChanges(this._cachedChanges);
    } else {
      throw new Error('Layout not found: ' + this.layout);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.componentRef) {
      const props = Object.keys(changes);
      for (const prop of props) {
        set(this.componentRef.instance, prop, changes[prop].currentValue);
        if (prop === 'legends' && this.componentRef.instance.updateLegends) {
          this.componentRef.instance.updateLegends(changes[prop].currentValue);
        }
      }
    } else {
      Object.assign(this._cachedChanges, changes);
    }
  }
}
